import { useState } from 'react';
import Raven from 'raven-js';
import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Form } from 'foundations-components/transitional/components/Form';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { SENTRY_KEYS } from 'campaigns-lib/constants/sentry';
import { createCampaign } from '../../data/CampaignDao';
import useCampaignNameValidation from '../../hooks/useCampaignNameValidation';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { UsageTracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MiniCreateCampaignPanel = ({
  onClose,
  onCreated,
  assetObjectType
}) => {
  const [campaignName, setCampaignName] = useState('');
  const {
    isCampaignNameValid,
    campaignNameValidationError
  } = useCampaignNameValidation(campaignName);
  const [isLoading, setIsLoading] = useState(false);
  const [displayError, setDisplayError] = useState();
  const portalId = PortalIdParser.get();
  const handleSubmit = e => {
    e.preventDefault();
    setIsLoading(true);
    setDisplayError(undefined);
    createCampaign({
      display_name: campaignName
    }).then(campaign => {
      UsageTracker.track('campaignsCreate', Object.assign({
        action: 'campaign created',
        applicationId: 'marketing-studio-ui',
        screen: 'campaign-select'
      }, assetObjectType && {
        assetType: assetObjectType
      }, {
        campaignGuid: campaign.guid || '',
        campaignId: campaign.objectId || ''
      }));
      onCreated(campaign);
      onClose();
    }).catch(error => {
      if (error.status === 409) {
        setDisplayError(I18n.text('campaignsLib.errors.existingName.message'));
      } else {
        setDisplayError(I18n.text('campaignsLib.errors.campaignCreateFailed.title'));
        Raven.captureException(error, {
          fingerprint: [SENTRY_KEYS.MINI_CREATE_CAMPAIGN_FAILED],
          tags: {
            lib: 'campaigns-lib'
          }
        });
      }
      setIsLoading(false);
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    width: "550px",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignsLib.miniCampaignCreatePanel.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(Form, {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsxs(DialogBody, {
        children: [displayError && /*#__PURE__*/_jsx(Alert, {
          type: "danger",
          children: displayError
        }), /*#__PURE__*/_jsx(FormControl, {
          required: true,
          label: I18n.text('campaignsLib.miniCampaignCreatePanel.name'),
          marginBlockEnd: "200",
          error: !isCampaignNameValid,
          validationMessage: campaignNameValidationError && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: campaignNameValidationError.message,
            options: campaignNameValidationError.options
          }),
          children: /*#__PURE__*/_jsx(TextInput, {
            name: "campaignName",
            placeholder: I18n.text('campaignsLib.miniCampaignCreatePanel.name'),
            value: campaignName,
            onChange: e => setCampaignName(e.target.value)
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          as: "p",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "campaignsLib.miniCampaignCreatePanel.details_jsx",
            elements: {
              Link
            },
            options: {
              href: `/marketing/${portalId}/studio/home/overview`,
              target: '_blank',
              underline: true,
              typography: 'detail-100'
            }
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          use: "primary",
          type: "submit",
          loading: isLoading,
          disabled: !isCampaignNameValid,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaignsLib.miniCampaignCreatePanel.create"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaignsLib.miniCampaignCreatePanel.cancel"
          })
        })]
      })]
    })]
  });
};
export default MiniCreateCampaignPanel;